import * as API from "./base";
const exports = API.crudify("template", "/api/templates");
export const create = exports.create;
export const destroy = exports.destroy;
export const index = exports.index;
export const show = exports.show;
// export const create = params => API.post("/api/templates/user_create", params)
// export const show = id => API.get("/api/templates/" + id)
